import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { AuthGuard } from './helpers/auth.guard';
// import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { NotAuthComponent } from './pages/not-auth/not-auth.component';
import { ErrorComponent } from './pages/error/error.component';
import { BlankLayoutComponent } from './layouts/blank-layout/blank-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthGuard } from './helpers/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) },
    ]
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: (localStorage.getItem('baseRoute') || ''), pathMatch: 'full' },
      { path: 'central-apps', loadChildren: () => import('./features/central-apps-hub/central-apps-hub.module').then(m => m.CentralAppsHubModule) },
      { path: 'administration-panel', loadChildren: () => import('./features/administration-panel/administration-panel.module').then(m => m.AdministrationPanelModule) },
      { path: 'credentials-management', loadChildren: () => import('./features/credentials-management/credentials-management.module').then(m => m.CredentialsManagementModule) },

    ]
  },
  { path: 'notAuthorized', component: NotAuthComponent },
  { path: 'notFound', component: ErrorComponent },
  { path: '**', component: ErrorComponent },
  // otherwise redirect to home
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
